
<template>
  <div>
    <div>
      <!--BUSQUEDA DE INSTITUCIONES Y TIPO DE VENTA-->
      <vs-row class="mt-3">
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
          <div style="width:100%; display: flex; flex-wrap: wrap;">
            <!-- Sección de búsqueda -->
            <div class="d-flex flex-column" style="flex: 1; margin-right: 10px;">
              <p>Búsqueda de la institución</p>
              <vs-input
                icon="search"
                class="mt-2"
                style="width: 100%;"
                placeholder="Search"
                @keyup.enter="getInstitucion()"
                v-model="busquedaInstitucion" />
            </div>

            <!-- Botón de búsqueda -->
            <div class="d-flex align-items-center" style="margin-top: 15px; width: auto;">
              <vs-button
                radius
                color="warning"
                class="mt-3 ml-1"
                @click="getInstitucion()"
                type="filled"
                icon="search">
              </vs-button>
            </div>

            <!-- Radio buttons para el estado de venta -->
            <div class="d-flex flex-column mt-8 ml-5" style="flex: 1; margin-top: 15px;">
              <span>
                <ul class="flex mt-2">
                  <li>
                    <vs-radio v-model="venta_estado" class="mr-3" vs-name="radios1venta_estado" vs-value="1">Venta directa</vs-radio>
                  </li>
                  <li>
                    <vs-radio v-model="venta_estado" vs-name="radios1venta_estado" vs-value="2">Venta lista</vs-radio>
                  </li>
                </ul>
              </span>
            </div>

          </div>
        </vs-col>
      </vs-row>
      <!--INSTITUCION ASIGNADA-->
      <vs-row v-if="nombreInstitucion.length > 1" class="mb-4">
        <vs-col vs-justify="left" vs-align="left" vs-w="12" vs-sm="12" vs-xs="12" vs-class="w-full" align="center">
          <div v-if="nombreInstitucion.length > 1" style="width: 100%;display: flex;flex-direction: column;">
        <div>
          <p width="100%" class="mt-6">
            <b style="font-style: italic;">Institucion asignada:
            {{nombreInstitucion}}</b><span> <b class="text-primary"> <br>( Período: {{ periodoDescripcion }} )</b></span>
          </p>
        </div>
        <div class="flex justify-center">
          <vs-button color="danger" style="scale: 1.5;" @click="eliminarInstitucionSeleccionada()" type="flat" icon="delete"></vs-button>
        </div>
      </div>
      </vs-col>
    </vs-row>
      <!--TABLA INSTITUCIONES-->
      <vs-row v-if="instituciones.length > 0">
        <vs-col vs-type="flex" vs-justify="center"  vs-align="center" vs-w="6" class="mt-5" style="flex-wrap:wrap;" v-if="userRoot">
          <small>Seleccione un período</small>
          <v-select :options="arrayPeriodos" @input="changePeriodo()" :reduce="arrayPeriodos => arrayPeriodos" label="periodoescolar" class="w-full" v-model="periodoSelect" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center"  vs-align="center" vs-w="12">
          <vs-table stripe max-items="50"  style="width: 100%;" search pagination :data="instituciones">
              <template slot="header">
                <div class="vx-row">
                  <div class="vx-col w-full m-3">
                      Cantidad: {{instituciones.length}}
                  </div>
                </div>
              </template>
              <template slot="thead">
              <vs-th sort-key="idInstitucion" style="width: 20%;">#</vs-th>
              <vs-th sort-key="nombreInstitucion" style="width: 40%;">Institución (asesor)</vs-th>
              <vs-th sort-key="nombre" style="width: 20%;">Localidad</vs-th>
              <vs-th sort-key="nombre" style="width: 20%;">Periodo</vs-th>
              <vs-th sort-key="nombre" style="width: 20%;">Acción</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].idInstitucion ">
                    {{data[indextr].idInstitucion }}
                  </vs-td>
                  <vs-td :data="data[indextr].nombreInstitucion">
                    {{data[indextr].nombreInstitucion}}<br>
                    <p><b>Ruc:</b> {{ tr.ruc }}</p>
                    <p><b>Teléfono:</b> {{ tr.telefonoInstitucion }}</p>
                    <div v-if="data[indextr].nombre_asesor == null &&  data[indextr].apellido_asesor == null">
                        <small> <i style="color:red;">No existe asesor </i></small><br>
                    </div>
                    <div v-else>
                        <small> <i>{{data[indextr].nombre_asesor}} {{data[indextr].apellido_asesor}} </i></small><br>
                    </div>
                    <small>{{data[indextr].fecha_registro}} </small>
                  </vs-td>
                  <vs-td :data="data[indextr].nombreregion">
                      {{data[indextr].nombreregion}} <br>
                      <small>{{data[indextr].ciudad}}</small>
                  </vs-td>
                  <vs-td>
                    <div v-if="tr.EstadoConfiguracion == 1">
                        {{ tr.periodoNombreConfigurado }}
                        <p class="font-medium" style="color:#ff5733;">
                          Se tomará un periodo activo de la lista de periodos escolares asignados a bodega.
                        </p>
                    </div>
                    <div v-else>
                      <small class="" >{{ tr.periodo }}</small><br>
                      <vs-chip v-if="tr.statusPeriodo == '1'" color="success" style="margin-left:-5px;">{{ tr.estadoPeriodo }}</vs-chip>
                      <vs-chip v-else color="danger" style="margin-left:-5px;">{{ tr.estadoPeriodo }}</vs-chip>
                    </div>
                  </vs-td>
                  <vs-td>
                      <vs-button type="relief" size="small" @click="asignarInstitucion(tr)">Asignar Institución</vs-button>
                  </vs-td>
                </vs-tr>
              </template>
          </vs-table>
        </vs-col>
      </vs-row>
      <!--FILTRO RADIOS-->
      <vs-row class="ml-2" style="margin-top: -15px;">
        <vs-divider v-if="activeTypes">Tipos</vs-divider>
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12" v-if="activeTypes">
          <ul class="flex" style="flex-wrap: wrap;">
            <li class="m-2" v-if="activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="0">Usan y liquidan</vs-radio>
            </li>
            <li class="m-2" v-if="!activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="0">Usan y liquidan</vs-radio>
            </li>
            <li class="m-2" v-if="!activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="1">Regalado (No entra a la liquidación)</vs-radio>
            </li>
            <li class="m-2" v-if="!activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="2">Regalados y bloqueado (No usan y no liquidan)</vs-radio>
            </li>
            <li class="m-2" v-if="!activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="3">BLOQUEADO (No usan y no liquidan)</vs-radio>
            </li>
            <li class="m-2" v-if="!activePaquete">
              <vs-radio v-model="radioRegalado" @input="codigosPerdidos=false;" vs-name="radios1Regalado" vs-value="4">GUIA</vs-radio>
            </li>
          </ul>
        </vs-col>
      </vs-row>
      <!--SI ES GUIA GUARDAR PERIODO Y ASESOR-->
      <vx-card title="Datos GUIA" v-if="radioRegalado == 4">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <p>Seleccione el período <span class="text-danger">(Obligatorio)</span></p>
            <v-select :options="arrayPeriodos" :reduce="arrayPeriodos => arrayPeriodos" label="periodoescolar" class="w-full mt-2" v-model="periodoSelect" />
          </div>
          <div class="vx-col w-1/2">
            <p>Seleccione el asesor que va recibir las guias <span class="text-danger">(Obligatorio)</span></p>
            <v-select :options="arrayAsesores" :reduce="arrayAsesores => arrayAsesores.id_asesor" label="asesor" class="w-full mt-2" v-model="asesorSelect" />
          </div>
        </div>
      </vx-card>
      <!--DOCUMENTOS VENTAS-->
      <vx-card title="Documentos" v-if="institucion_id > 0" class="mt-2">
        <span v-if="comboSelected || tipoComboImportacion == 1">
          <!--Obligatorio seleccionar un documento prefactura / nota si se selecciona un combo-->
          <p v-if="!proforma.proforma" class="text-danger"><i class="fa-solid fa-triangle-exclamation"></i> Obligatorio seleccionar un documento prefactura / nota si se selecciona un combo</p>
        </span>
        <div class="vx-row">
          <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <small>Empresa:</small>
            <v-select :options="arrayEmpresas" @input="comboSelected='';f_listadoProformasAgrupadas();" :reduce="arrayEmpresas => arrayEmpresas.id" label="nombre" class="w-full" v-model="proforma.empresa" />
          </div>
          <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <small>Documentos:</small>
            <v-select :options="arrayProformas" :reduce="arrayProformas => arrayProformas.ven_codigo" label="ven_codigo" class="w-full" v-model="proforma.proforma" @input="comboSelected='';f_validarComboDocumento();validacionDocumentoNoCombos();" />
          </div>
        </div>
      </vx-card>
      <!--COMBOS-->
      <vx-card title="Sección Combos" subtitle="(Seleccione una empresa y un documento para buscar los combos)" class="mt-2" v-if="tipoBodega == 4 && nombreInstitucion && tableData.length > 0">
        <div>
          <ul class="flex">
            <li class="mr-3">
              <p>Tipo de combo:</p>
            </li>
            <li class="mr-3">
              <vs-radio v-model="tipoComboImportacion" vs-name="radios1tipoComboImportacion" @input="comboSelected='';errorComboEnDocumento=false;" vs-value="0">Se tomara la columna codigo del excel</vs-radio>
            </li>
            <li>
              <vs-radio v-model="tipoComboImportacion" @input="comboSelected='';errorComboEnDocumento=false;getCombos();f_validarComboDocumento();" vs-name="radios1tipoComboImportacion" vs-value="1">Se tomara la columna codigo y la columna combo del excel</vs-radio>
            </li>
          </ul>
        </div>
        <div class="vx-row" v-if="tipoComboImportacion == 0">
          <div v-if="tipoBodega == 4">
            <p v-if="!comboSelected" class="text-danger ml-3">!Es obligatorio elegir un combo del libro</p>
          </div>
          <div class="vx-col w-full sm:w-full">
            <small>Combo del libro:</small>
            <v-select :options="arrayCombos" :reduce="arrayCombos => arrayCombos.pro_codigo" label="combolibro" class="w-full" v-model="comboSelected" @input="f_validarComboDocumento();" />
          </div>
        </div>
      </vx-card>
      <!--FIN PERSEO-->
      <br><br>

      <div class="vx-row" style="margin-top:-15px;">
        <!--FACTURA-->
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
          <div class="flex">
            <ul class="centerx">
              <li>
                <vs-checkbox  v-model="checkFactura" class="ml-5 mt-2">Guardar factura</vs-checkbox>
              </li>
            </ul>
            <!--FACTURA-->
            <div v-if="checkFactura">
              <vs-input class="w-full" @keydown.space="(event) => event.preventDefault()" v-model="factura" placeholder="Factura | Ejemplo. F-9999"/>
            </div>
            <div v-if="arregloCodigosDiagnosticoNoexisten.length > 0">
              <vs-button color="dark" size="small" class="ml-2 p-3" @click="popupCodigosDiagnosticoNoexisten = true;" style="margin-top: -3px;" type="filled">MOSTRAR CÓDIGOS NO EXISTE DIÁGNOSTICO</vs-button>
            </div>
          </div>
        </div>
        <!--</FACTURA-->
        <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
          <vs-input icon="icon-message-square" class="w-full" icon-pack="feather" placeholder="Comentario" v-model="observacion"/>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="mb-6 mt-4" align="center">
        <div class="vx-col w-full">
          <p style="color:#2D9ADA;" v-if="tableData.length == 0">
            <i class="fa fa-file" aria-hidden="true"></i>Importacion de códigos <span style="font-weight: bold;">(no ingrese más de 1500 registros en una sola carga.)</span>
          </p>
        </div>
        <vs-alert v-if="tableData.length > 0" color="warning" style="height:100px;" class="mb-3 mt-2"  icon-pack="feather" icon="icon-alert-triangle">
          <p class="text-2xl font-bold text-center">{{ titleImportacion }}</p>
          <vs-divider style="margin-top:-2px;"></vs-divider>
          <span>Excel cargado exitosamente. ¿Estás seguro de importar estos <b>{{ totalCodigos }}</b> códigos?</span><br>
        </vs-alert>
        <!-- Botones de acción -->
        <div>
          <vs-button class="mb-2" color="danger" v-if="radioRegalado!=='' && tableData.length > 0"  @click="validacionDocumentoNoCombos();openConfirm(0)">Importar códigos </vs-button>
          <vs-button v-if="arregloProblemasDiagnostico.length > 0 || arregloProblemasPaquete.length > 0" class="mb-2 ml-5" color="danger"  type="border" @click="popupProblemasDiagnostico = true;"><i class="fa-solid fa-triangle-exclamation"></i> Mostrar errores </vs-button>
          <vs-button v-if="arrayCodigosNoEnDocumento.length > 0" class="mb-2 ml-5" color="danger"  type="border" @click="popupCodigosGeneralesError = true;"><i class="fa-solid fa-triangle-exclamation"></i> Mostrar errores documento</vs-button>
          <!--boton para mostrar combos con errores-->
          <vs-button v-if="arrayErroresValidacionCombos.length > 0" class="mb-2 ml-5" color="danger"  type="border" @click="popupMostrarErroresCombosNoCoindicen = true;"><i class="fa-solid fa-triangle-exclamation"></i> Mostrar errores combos </vs-button>
        </div>
        <!---CONTADOR DE CODIGOS INGRESADOS-->
        <vs-row v-if="codigosPerdidos == true" class="mt-5">
          <div v-if="tipoBodega === '1' || tipoBodega === '2'" style="width: 100%;" class="flex justify-center">
            <ul class="features flex justify-center">
              <li>
                <span class="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path fill="currentColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                  </svg>
                </span>
                <span><strong>Códigos Activación Importados: {{ contadorA }} </strong></span>
              </li>
              <li>
                <span class="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path fill="currentColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                  </svg>
                </span>
                <span><strong>Códigos Diágnostico Importados: {{ contadorD }} </strong></span>
              </li>
              <li>
                <span class="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path fill="currentColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                  </svg>
                </span>
                <span><strong>Total Importados: {{ contadorA+ contadorD }} </strong></span>
              </li>
              <li v-if="sumaNoIngresados > 0">
                <span class="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path fill="currentColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                  </svg>
                </span>
                <span><strong class="text-danger">Códigos No ingresados: {{ sumaNoIngresados }} </strong></span>
              </li>
            </ul>
          </div>
          <vs-col v-if="tipoBodega === '0'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-alert active="true" >
                Se importo   {{ porcentaje }} códigos
                <vs-button v-if="codigosSinCodigoUnion.length > 0" @click="popupProblemasCodigosUnion = true;" color="primary" type="border">Mostrar códigos sin código unión</vs-button>
            </vs-alert>
          </vs-col>
        </vs-row>
        <!--RESUMEN PAQUETES-->
        <div v-if="codigosPerdidos == true && (tipoBodega === '3' || tipoBodega === '4')">
          <vs-card v-if="arregloErroresPaquetes.length > 0">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vs-list>
                  <p>Cantidad <span>{{ arregloErroresPaquetes.length }}</span></p>
                    <vs-list-header icon="supervisor_account" :title="'Hubo problemas con algunos '+(tipoBodega === 3 ? 'paquetes' : 'combos')"></vs-list-header>
                    <vs-list-item :key="indextr" v-for="(tr, indextr) in arregloErroresPaquetes" icon="check" :title="tr.paquete" >
                      <p> {{ tr.problema }}</p>
                    </vs-list-item>
                </vs-list>
            </vs-col>
          </vs-card>
          <div>
            <p class="font-bold">Importado como: {{ titleImportacion }}</p>
          </div>
          <TableResumenPaqueteVue :arregloResumen="arregloResumen" :arregloFormatoSend="arregloFormatoSend" class="mt-1"/>
        </div>
         <!---FIN CONTADOR DE CODIGOS INGRESADOS-->
        <br/>
        <import-excel :onSuccess="loadDataInTable"  class="mb-4" />
        <vs-row >
          <vs-col v-if="codigosNoCambiados.length > 0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-list>
              <vs-list-header icon="supervisor_account" title="Códigos que no se pudieron cambiar"></vs-list-header>
              <vs-list-item :key="indextr" v-for="(tr, indextr) in codigosNoCambiados" icon="check" :title="tr.codigo" >
                <p v-if="tr.mensaje !='0'"> {{ tr.mensaje }}</p>
              </vs-list-item>
            </vs-list>
          </vs-col>
          <vs-col v-if="codigosNoExisten.length > 0" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-list>
              <vs-list-header icon="supervisor_account" title="Códigos que no existen"></vs-list-header>
              <vs-list-item :key="indextr" v-for="(tr, indextr) in codigosNoExisten" icon="check" :title="tr.codigo" >
              </vs-list-item>
            </vs-list>
          </vs-col>
        </vs-row>
        <vs-row>
        </vs-row>
        <vs-row v-if="codigosPerdidos == true">
          <vx-card
            title="Codigos que no se pudieron guardar"
            v-if="codigoConProblemas.length > 0"
            >
            <TableRadiosCodigosListaVue :arregloCodigos="codigoConProblemas" :openModal="Number(1)" :ifErrorProforma="Number(1)"/>
          </vx-card>
        </vs-row>
      </div>
      <vx-card v-if="tableData.length && header.length">
        <vs-table stripe pagination :max-items="10" search :data="tableData">
          <template slot="header">
            <h4>Códigos a subir {{tableData.length}}</h4>
          </template>
          <template slot="thead">
            <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
                {{ col }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <!--MODALES-->
    <vs-popup title="Errores en excel de los codigos" :active.sync="modalErrores" style="padding: 0% !important;">
      <div class="w-full" style="background: rgb(121,9,9); padding: 20px; border-radius: 5px; background: linear-gradient(90deg, rgba(121,9,9,1) 28%, rgba(255,0,48,1) 100%); color: white;">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <b>Código</b>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <b>Institución</b>
          </div>
        </div>
        <vs-divider></vs-divider>
        <div :key="index" v-for="(item, index) in errores">
          <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <span v-if="item.codigo"> {{item.codigo}} </span>
              </div>
          </div>
        </div>
      </div>
    </vs-popup>
    <!--MODAL PARA CONFIRMAR-->
    <vs-popup small title="Confirmación" :active.sync="modalConfirm">
      <div v-if="modalConfirm">
        <p class="text-2xl font-bold text-center">{{ titleImportacion }}</p>
        <vs-divider style="margin-top:-2px;"></vs-divider>
        <p class="text-center" v-if="radioRegalado == '0'">Acción: Usan y liquidan</p>
        <p class="text-center" v-if="radioRegalado == '1'">Acción: Regalado no entra a liquidacion</p>
        <p class="text-center" v-if="radioRegalado == '2'">Acción: Regalados y bloqueados (No usan ni liquidan)</p>
        <p class="text-center" v-if="radioRegalado == '3'">Acción: Bloqueados (No usan ni liquidan)</p>
        <p class="text-center" v-if="radioRegalado == '4'">Acción: GUIA</p>
        <div class="w-full mb-base mt-2" align="center">
          <h4>Está seguro de aplicar estos
            <span class="text-success">{{ totalCodigos }}</span>
            códigos? al periodo
            <b class="text-danger" v-if="radioRegalado == 4">{{  periodoSelect.periodoescolar }}</b>
            <b class="text-danger" v-else>{{  periodoDescripcion }}</b>
          </h4>
        </div>
        <!--si sube un documento proforma-->
        <div v-if="proforma.proforma">
          <div class="w-full mb-base mt-2" align="center">
            <h4>Documento a asignar a los códigos?
              <b class="text-danger">{{ proforma.proforma }}</b>
            </h4>
            <!--nombre de empresa-->
            <h4>Empresa:
              <b class="text-danger">{{ arrayEmpresas.find(p => p.id == proforma.empresa).nombre }}</b>
            </h4>
          </div>
        </div>
        <!--si seleccion un combo-->
        <div v-if="comboSelected">
          <div class="w-full mb-base mt-2" align="center">
            <h4>Combo a asignar a los códigos?
              <b class="text-danger">{{ comboSelected }}</b>
            </h4>
          </div>
        </div>
        <!--tipoComboImportacion = 1 -->
        <div v-if="tipoComboImportacion == 1">
          <div class="w-full mb-base mt-2" align="center">
            <h4>Combo a asignar a los códigos?</h4>
            <b class="text-danger">Se añadirá el combo del libro que se encuentra en la columna de combo de su archivo</b>
          </div>
        </div>
        <!---CODIGO BLOQUEADOS-->
        <div v-if="arrayCodigosBloqueados.length > 0 && radioRegalado == '0'">
          <p class="text-danger text-center">Hay códigos que están bloqueados (No regalados)</p>
          <!-- <p class="mt-1">Al colocar "NO", no se van a asignar <b>{{ arrayCodigosBloqueados.length }}</b> códigos</p> -->
          <TableReutilizableVue
          :title="'Codigos Bloqueados'"
          :headers="['codigo']"
          :fieldKeys="['codigo']"
          :ifexportar="Number(1)"
          :maxItems="5"
          :tableData="arrayCodigosBloqueados"
          />
        </div>
        <div class="w-full" align="center">
          <vs-button class="mb-2" color="danger" type="gradient" @click="procesarPagos()"> Confirmar </vs-button>
        </div>
      </div>
    </vs-popup>
    <!--MODAL PROBLEMAS DIAGNOSTICO O PAQUETES-->
    <vs-popup fullscreen small title="Problemas con los códigos de su archivo" :active.sync="popupProblemasDiagnostico">
      <div v-if="tipoBodega == 1 || tipoBodega == 2">
        <TableProblemasDiagnosticoVue v-if="popupProblemasDiagnostico" :items="10" :arregloProblemasDiagnostico="arregloProblemasDiagnostico"/>
      </div>
      <div v-if="tipoBodega == 3 || tipoBodega == 4">
        <TablaErroresPaqueteVue v-if="popupProblemasDiagnostico" :items="10" :arregloProblemasPaquete="arregloProblemasPaquete" :tipoImortacion="tipoBodega == 3 ? 'paquete' : 'combo'"/>
      </div>
    </vs-popup>
    <vs-popup small title="Codigos diágnostico no existen" :active.sync="popupCodigosDiagnosticoNoexisten">
      <TableProblemasDiagnosticoVue v-if="popupCodigosDiagnosticoNoexisten" :items="5" :arregloProblemasDiagnostico="arregloCodigosDiagnosticoNoexisten"/>
    </vs-popup>
    <!--MODAL CONFIRMAR TIPO DE IMPORTADO-->
    <vs-popup small title="Tipo de Importación" :active.sync="popupConfirmTipoImportado" @close="popupConfirmTipoImportado=true;">
      <div v-if="popupConfirmTipoImportado">
        <TipoImportacionVue v-if="popupConfirmTipoImportado" @changeTipo="changeTipo" :tableData="tableData"/>
        <div class="flex justify-center mt-2">
          <vs-button class="mt-2" color="danger" @click="popupConfirmTipoImportado=false;f_limpiarCancelar();"><i class="fa-solid fa-circle-xmark"></i> Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
      <!--MODAL PARA MOSTRAR CODIGOS SIN CODIGO UNION-->
      <vs-popup classContent="popup-example" title="Códigos sin código Unión" fullscreen :active.sync="popupProblemasCodigosUnion">
      <gestionCodigosLista :arregloCodigos="codigosSinCodigoUnion" :openModal="Number(0)"/>
    </vs-popup>
    <!--MODAL PARA MOSTRAR ERRORES COMBOS NO COINDICEN-->
    <vs-popup title="Errores en combos" :active.sync="popupMostrarErroresCombosNoCoindicen" fullscreen>
      <!--table reutilizable-->
      <TableReutilizableVue

        :title="'Errores en combos'"
        :headers="['combo etiqueta','combo del libro', 'Libros del combo', 'problema']"
        :fieldKeys="['codigoCombo', 'combo', 'codigos_combos', 'error']"
        :ifexportar="Number(1)"
        :maxItems="5"
        :tableData="arrayErroresValidacionCombos"
      />
    </vs-popup>
    <!--MODAL PARA MOSTRAR ERRORES EN CODIGOS NO ENCONTRADOS EN EL DOCUMENTO-->
    <vs-popup title="Códigos no encontrados en el documento" :active.sync="popupCodigosGeneralesError" fullscreen>
      <!--table reutilizable-->
      <TableReutilizableVue

        :title="'Códigos no encontrados en el documento'"
        :headers="['Código','Mensaje']"
        :fieldKeys="['codigo','message']"
        :ifexportar="Number(1)"
        :maxItems="5"
        :tableData="arrayCodigosNoEnDocumento"
      />
    </vs-popup>
  </div>
</template>
<script>
import gestionCodigosLista from '../../gestionCodigosLista.vue'
import ImportExcel from '@/views/codigos/components/importExcel'
import vSelect from 'vue-select'
import TableProblemasDiagnosticoVue from '../../TableProblemasDiagnostico.vue'
import TipoImportacionVue from '@/views/codigos/components/utils/components/GestionLiquidacion/TipoImportacion'
const TablaErroresPaqueteVue             = () => import('@/views/codigos/paquetes/components/TablaErroresPaquete')
const TableResumenPaqueteVue             = () => import('@/views/codigos/components/utils/components/GestionLiquidacion/TableResumenPaquete')
const TableRadiosCodigosListaVue         = () => import('./TableRadiosCodigosLista.vue')
const TableReutilizableVue               = () => import('@/views/pedidos2/pedidos/reportes/components/TableReutilizable.vue')
import PeriodoRepository from '@/repositories/PeriodoRepository'
import PedidosRepository from '../../../../../../repositories/PedidosRepository'
import LibroRepository from '../../../../../../repositories/LibroRepository'
import Generalmix from '../../../../../../mixins/Generalmix'
import Paquetemix from '../../../../../../mixins/Paquetemix'
  import {
    mapState
} from "vuex";
export default {
  mixins: [Generalmix, Paquetemix],
  components: {
    ImportExcel,
    vSelect,
    gestionCodigosLista,
    TableProblemasDiagnosticoVue,
    TipoImportacionVue,
    TablaErroresPaqueteVue,
    TableResumenPaqueteVue,
    TableRadiosCodigosListaVue,
    TableReutilizableVue,
  },
  data () {
    return {
      codigosPerdidos:false,
      tableData: [],
      header: [],
      sheetName: '',
      usuario: [],
      modalConfirm: false,
      modalErrores: false,
      errores: [],
      cedulas_no_encontradas: [],
      codigosNoCambiados:[],
      arregloCodigosDiagnosticoNoexisten:[],
      popupCodigosDiagnosticoNoexisten:false,
      porcentaje:0,
      instituciones:[],
      busquedaInstitucion:'',
      nombreInstitucion:'',
      EstadoConfiguracion:0,
      institucion_id:0,
      periodo_id:0,
      radioRegalado:'',
      venta_estado:0,
      cantidadNoExisten:0,
      error:false,
      periodoDescripcion:'',
      ciudadDescripcion:'',
      factura:'',
      checkFactura:true,
      //VARIABLES PARA TIPO DE ACTIVACION O DIAGNOSTICO
      tipoBodega:0,
      arregloProblemasDiagnostico:[],
      popupProblemasDiagnostico:false,
      popupConfirmTipoImportado:false,
      contadorA:0,
      contadorD:0,
      titleImportacion:'Importacion Sticker (Activación)',
      //FIN VARIABLES PARA TIPO DE ACTIVACION O DIAGNOSTICO
      //variables para codigos union
      codigosSinCodigoUnion:[],
      popupProblemasCodigosUnion:false,
      //fin variables para codigos union
      totalCodigos:0,
      //variables paquete
      cantidadPaquete:20,
      //FIN VARIABLES PARA TIPO DE ACTIVACION O DIAGNOSTICO
      //VARIABLES PARA ERRORES CODIGOS PAQUETES
      arregloProblemasPaquete:[],
      arregloFormatoSend:[],
      arregloFormatoSendOriginal:[],
      arrayPaquetes:[],
      arregloErroresPaquetes:[],
      codigoConProblemas:[],
      //FIN VARIABLES PARA ERRORES CODIGOS PAQUETES
      //fin variables paquetes
      observacion:'',
      activeTypes:false,
      activePaquete:false,
      //VARIABLES PARA PERIODOS EN EL ROOT
      arrayPeriodos:[],
      periodoSelect:'',
      //FIN VARIABLES PARA PERIODOS EN EL ROOT
      arrayProformas:[],
      arrayEmpresas:[
        {
          id:1,
          nombre:'Prolipa'
        },
        {
          id:3,
          nombre:'Calmed'
        }
      ],
      proforma:{
        empresa:'',
        proforma:''
      },
      //variables para guias
      arrayAsesores:[],
      asesorSelect:'',
      //fin variables para guias
      //variables combos
      popupMostrarErroresCombosNoCoindicen:false,
      arrayAgrupadosCombos:[],
      arrayAllCombos:[],
      arrayCombos:[],
      comboSelected:'',
      tipoComboImportacion:0,
      errorCombos:false,
      errorComboEnDocumento:false,
      arrayErroresValidacionCombos:[],
      //fin variables combos
      //variables para previsualizar
      CodigosNoEncontrados:[],
      arrayCodigosEncontrados:[],
      //fin variables para previsualizar
      arrayCodigosBloqueados:[],
      errorDocumentos:false,
      codigosNoExisten:[], // Moved from duplicate declaration
      arrayCodigosNoEnDocumento:[], // Moved from duplicate declaration
      popupCodigosGeneralesError:false,
    }
  },
  created(){
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    this.codigosPerdidos = false
  },
  mounted(){
    let me = this;
    me.obtenerPeriodos()
    me.getAsesores()
    me.getCombos()
  },
  watch:{
    factura(newValue, oldValue){
      if(newValue !== "" && newValue !== oldValue){
        const cleanedValue = newValue.replace(/\s/g, "");
        if(cleanedValue !== newValue) {
          this.$nextTick(() => {
            this.factura = cleanedValue;
          });
        }
      }
    }
  },
  computed:{
    sumaNoIngresados(){
      let me = this;
      if(me.codigosPerdidos){
        let total      = me.totalCodigos - (me.contadorA + me.contadorD)
        return total
      }
    },
    ...mapState(["auth",'userRoot','susuario','groupFacturador']),

  },
  methods: {
    getCombos(){
      let me = this
      LibroRepository.getAllCombos().then(r => { this.arrayAllCombos = r.data });
    },
    obtenerPeriodos(){
      let me = this;
      PeriodoRepository.getPeriodos().then( p => { me.arrayPeriodos = p.data; });
    },
    getAsesores(){
      let me = this
      return PedidosRepository.rep_getAsesores().then(r => { me.arrayAsesores = r.data } )
    },
    changeTipo(e,sendData){
      let me = this
      me.CodigosNoEncontrados       = [];
      me.arrayCodigosEncontrados    = [];
      me.arrayCodigosBloqueados     = [];
      me.arrayErroresValidacionCombos = [];
      me.CodigosNoEncontrados       = sendData.CodigosNoEncontrados
      me.arrayCodigosEncontrados    = sendData.arrayCodigosEncontrados
      // Transformar arrayAgrupadosCombos para que codigosHijos solo contenga códigos de activación con propiedad 'codigo'
      me.arrayAgrupadosCombos       = sendData.arrayAgrupadosCombos.map(combo => ({
        ...combo,
        codigosHijos: combo.codigosHijos.map(hijo => ({
          codigo: hijo.codigoActivacion,
          codigo_liquidacion: hijo.codigo_liquidacion,
        }))
      }))
      //obtener codigos bloqueados
      me.arrayCodigosBloqueados     = me.arrayCodigosEncontrados.filter(p => p.estado == 2 && p.estado_liquidacion != 2)
      //3 => paquetes, 4 => combos
      if(e.sendtipoBodega == 3)    { me.activeTypes = true;  me.activePaquete = true; me.radioRegalado = 0;}
      else                         { me.activeTypes = true; me.activePaquete = false; }
      me.tipoBodega                 = e.sendtipoBodega
      me.titleImportacion           = e.sendtitleImportacion
      me.cantidadPaquete            = e.sendcantidadPaquete
      me.popupConfirmTipoImportado  = false;
      me.ejecutarValidacion()
      // VALIDACION DOCUMENTO NO COMBOS
      me.validacionDocumentoNoCombos()
    },
    validacionDocumentoNoCombos() {
      let me = this;
      me.arrayCodigosNoEnDocumento = [];

      if (me.proforma.empresa && me.proforma.proforma && me.arrayCodigosEncontrados.length > 0 && me.tipoBodega != 4) {
        this.$http
          .get(
            this.$server_url +
              `metodosGetVentas?getProductoDetalleVenta=1&id_empresa=${me.proforma.empresa}&ven_codigo=${me.proforma.proforma}`
          )
          .then(function (res) {
            const data = res.data; // Datos de la API

            // Obtener todos los pro_codigo de la API
            const codigosApi = data.map(item => item.pro_codigo);

            // Recorrer los códigos de arrayCodigosEncontrados
            me.arrayCodigosEncontrados.forEach(c => {
              c.message = ''; // Reiniciar mensaje
              if (!codigosApi.includes(c.codigo_liquidacion)) {
                c.message = `el codigo ${c.codigo_liquidacion} No se encuentra en el documento`;
                // Guarda el objeto completo
                me.arrayCodigosNoEnDocumento.push(c);
              }
            });

            // Mostrar resultado
            if (me.arrayCodigosNoEnDocumento.length > 0) {
              // Puedes mostrar un modal de error si lo usas en tu app
              me.popupCodigosGeneralesError = true;
            }else{
              me.$vs.notify({
                color: 'success',
                title: 'Validación exitosa',
                text: 'Todos los códigos se encuentran en el documento.',
                icon: 'check_circle',
              });
            }
          })
          .catch(err => {
            console.error("Error al consultar la API:", err);
          });
      }
    },


    ejecutarValidacion(){
      let me = this;
      if(me.tipoBodega == 1 || me.tipoBodega == 2) { me.validateCodigos() }
      if(me.tipoBodega == 3) { me.validateCodigosPaquete() }
      if(me.tipoBodega == 4) { me.validateCodigosCombo() }
    },
    validateCodigos(){
      let me                            = this;
      try{
        let datos                       = []
        me.arregloProblemasDiagnostico  = []
        datos                           = me.tableData
        var preValores                  = []
        //quitar types NumRow
        datos.forEach(element => {
          var obj = new Object();
          obj.codigo = element.codigo.trim().toUpperCase()
          preValores.push(obj)
        });
        var getLongitud = datos.length
        var longitud    = getLongitud/2
        for(var i = 0; i<longitud;i++){
          // Creamos un nuevo array para almacenar los objetos quitados
          const nuevoArray        = [];
          let   codigoActivacion  = "";
          let   codigoDiagnostico = "";
          // Quitamos los dos primeros objetos del array original y los agregamos al nuevo array
          nuevoArray.push(preValores.splice(0, 2));
          var setear = nuevoArray.flat()
          //====VALIDACION SI SOLO HAY UN CODIGO====
          if(setear.length == 1){
            var cal = new Object
            //ACTIVACION - DIAGNOSTICO)
            if(me.tipoBodega == 1){
              cal.codigoActivacion =  setear[0].codigo
              cal.codigoDiagnostico  =  ""
            }
            //DIAGNOSTICO - ACTIVACION)
            if(me.tipoBodega == 2){
              cal.codigoDiagnostico =  setear[0].codigo
              cal.codigoActivacion  =  ""
            }
            cal.problema          =  'formato'
            me.arregloProblemasDiagnostico.push(cal)
          }
          //==SI TODO ESTA NORMAL===
          else{
            //ACTIVACION - DIAGNOSTICO)
            if(me.tipoBodega == 1){
              codigoActivacion      = setear[0].codigo;
              codigoDiagnostico     = setear[1].codigo
            }
            //DIAGNOSTICO - ACTIVACION)
            if(me.tipoBodega == 2){
              codigoDiagnostico     = setear[0].codigo
              codigoActivacion      = setear[1].codigo;
            }
            //============ACTIVACION==================================
            //VALIDACION SI NO SON STRING
            if (typeof codigoActivacion !== 'string' || typeof codigoDiagnostico !== 'string' ) {
              var cal = new Object
              cal.codigoActivacion  =  codigoActivacion
              cal.codigoDiagnostico =  codigoDiagnostico
              cal.problema          =  'formato'
              me.arregloProblemasDiagnostico.push(cal)
            }
            else{
              const activacionMinuscula = codigoActivacion.toLowerCase();
              //validar que el codigo de activacion no tenga una P
              if(activacionMinuscula.startsWith("p")){
                //validar meñique que el codigo de activacion se permita empezar por p DONDE SEA PLM no hago nada
                if(activacionMinuscula.startsWith("plm")){
                }else{
                  var cal = new Object
                  cal.codigoActivacion  =  codigoActivacion
                  cal.codigoDiagnostico =  codigoDiagnostico
                  cal.problema          =  'activacion'
                  me.arregloProblemasDiagnostico.push(cal)
                }
              }
              //=============DIAGNOSTICO===================================
              //validar que el codigo de activacion tenga una P
              const diagnosticoMinuscula = codigoDiagnostico.toLowerCase();
              //validar si es meñique debe tener 2 pp
              if(activacionMinuscula.startsWith("plm")){
                //si no inicia por 2 pp
                if(!diagnosticoMinuscula.startsWith("pp")){
                  var cal = new Object
                  cal.codigoActivacion  =  codigoActivacion
                  cal.codigoDiagnostico =  codigoDiagnostico
                  cal.problema          =  'diagnostico'
                  me.arregloProblemasDiagnostico.push(cal)
                }
              }
              //diferente a meñique
              else{
                if(!diagnosticoMinuscula.startsWith("p")){
                  var cal = new Object
                  cal.codigoActivacion  =  codigoActivacion
                  cal.codigoDiagnostico =  codigoDiagnostico
                  cal.problema          =  'diagnostico'
                  me.arregloProblemasDiagnostico.push(cal)
                }
              }
            }
          }
        }//Fin FOR
        //si hay errores en el archivo mostramos un modal
        if(me.arregloProblemasDiagnostico.length > 0){
          me.popupProblemasDiagnostico = true
        }
      }
      catch (err) {
        console.log("err",err)
        alert("Hubo problemas con tu archivo excel")
      }
    },
    //==================================METODOS PAQUETES===================
    validateCodigosPaquete() {
      let me = this;
      try {
        // Llamamos al método de validación y almacenamos los resultados en arregloFormatoSend
        const resultado = me.m_validatePaquete(me.tableData,'paquete','paq');  // Asumiendo que `validatePaquete` es tu método de validación
        me.arregloFormatoSend      = resultado.arregloFormatoSend;  // Asignamos los paquetes válidos
        me.arregloFormatoSendOriginal = resultado.arregloFormatoSend;
        me.arregloProblemasPaquete = resultado.arregloProblemasPaquete;  // Asignamos los problemas
        // Si hay errores en el archivo, mostramos el modal
        if (me.arregloProblemasPaquete.length > 0) {
          me.popupProblemasDiagnostico = true;
        }
      } catch (err) {
        console.log("err", err);
        alert("Hubo problemas con tu archivo excel");
      }
    },
    validateCodigosCombo() {
      let me = this;
      me.errorCombos = false
      try {
        // Llamamos al método de validación y almacenamos los resultados en arregloFormatoSend
        const resultado = me.m_validatePaquete(me.tableData,'combo','cmb');  // Asumiendo que `validatePaquete` es tu método de validación
        me.arregloFormatoSend = resultado.arregloFormatoSend;  // Asignamos los paquetes válidos
        me.arregloFormatoSendOriginal = resultado.arregloFormatoSend; // Guardamos el arreglo original
        me.arregloProblemasPaquete = resultado.arregloProblemasPaquete;  // Asignamos los problemas
        // Si hay errores en el archivo, mostramos el modal
        if (me.arregloProblemasPaquete.length > 0) {
          me.popupProblemasDiagnostico = true;
        }

      } catch (err) {
        console.log("err", err);
        alert("Hubo problemas con tu archivo excel");
      }
    },

    //===================================FIN METODOS PAQUETES===============
    eliminarInstitucionSeleccionada(){
      let me = this;
      me.nombreInstitucion = ""
      me.instituciones = []
      me.institucion_id = 0
      me.periodo_id = 0
      me.periodoDescripcion = ""
      //limpiar la proforma
      me.proforma.empresa = ""
      me.proforma.proforma = ""
    },
    changePeriodo(){
      let me = this
      if(me.instituciones.length > 0){
        me.instituciones.map(function (item) {
          item.EstadoConfiguracion      = 1
          item.periodo_configurado      = me.periodoSelect.idperiodoescolar
          item.periodoNombreConfigurado = me.periodoSelect.periodoescolar
        })
      }
    },
    getInstitucion() {
      let me = this;
      me.periodoSelect                        = ""
      me.codigosPerdidos                      = false
      me.instituciones                        = [];
      me.arregloCodigosDiagnosticoNoexisten   = []
      me.nombreInstitucion                    = "";
      me.institucion_id                       = 0;
      //limpiar la proforma
      me.proforma.empresa                     = ""
      me.proforma.proforma                    = ""
      if(me.busquedaInstitucion.length < 5){
        me.$vs.notify({
        text:'Minimo 5 caracteres de busqueda',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false;
      }
      me.$vs.loading()
      this.$http.get(this.$server_url + 'listaInsitucion?busqueda='+me.busquedaInstitucion)
        .then(function (res) {
          let datos = res.data
          me.instituciones = datos
          // if(datos.length > 0){
          //   me.instituciones = datos.filter(p => p.statusPeriodo == '1')
          // }
          me.$vs.loading.close()
          if(res.data.message){
            me.$vs.notify({
            text: res.data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-user'
            })
          }
        })
        .catch(function (error) {
          console.log(error + ' error');
          me.$vs.loading.close()
        })
    },
    asignarInstitucion(tr){
      let me = this;
      me.arrayProformas        = []
      me.error = false
      me.nombreInstitucion     = tr.nombreInstitucion
      me.institucion_id        = tr.idInstitucion
      me.EstadoConfiguracion   = tr.EstadoConfiguracion
      if(tr.EstadoConfiguracion == 1){
      me.periodo_id            = tr.periodo_configurado
      me.periodoDescripcion    = tr.periodoNombreConfigurado
      }else{
      me.periodo_id            = tr.periodo_id
      me.periodoDescripcion    = tr.periodo
      }
      me.ciudadDescripcion     = tr.ciudad
      me.instituciones         = []
      //limpiar la proforma
      me.proforma.empresa      = ""
      me.proforma.proforma     = ""
    },
    f_listadoProformasAgrupadas(){
      let me = this;
      me.arrayProformas = []
      me.proforma.proforma = ""
      if(me.proforma.empresa == "" || me.proforma.empresa == null || me.proforma.empresa == undefined){
        me.$vs.notify({
        text:'Debe seleccionar una empresa por favor',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false;
      }
      this.$http.get(this.$server_url+`devoluciones?listadoProformasAgrupadas=1&institucion=${me.institucion_id}&periodo_id=${me.periodo_id}`)
      .then(function (res) {
        let datos = res.data
        if(datos.length == 0){
          me.$vs.notify({
          text:'No hay documentos de la institución'+me.nombreInstitucion+ 'de la empresa '+me.arrayEmpresas.find(p => p.id == me.proforma.empresa).nombre,
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
        //filtrar emp_id con me.proforma.empresa
        me.arrayProformas = datos.filter(p => p.id_empresa == me.proforma.empresa)
        if(me.arrayProformas.length == 0){
          me.$vs.notify({
          text:'No hay documentos de la institución'+me.nombreInstitucion+ 'de la empresa '+me.arrayEmpresas.find(p => p.id == me.proforma.empresa).nombre,
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }else{
          //se encontrato tal resultados
          me.$vs.notify({
          text:'Se encontraron '+me.arrayProformas.length+' documentos de la institución '+me.nombreInstitucion+ ' de la empresa '+me.arrayEmpresas.find(p => p.id == me.proforma.empresa).nombre,
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
        }
      })
      .catch(function (error) {
          console.log(error + ' error');
      })
    },
    loadDataInTable ({ results, header, meta }) {
      let me = this;
      this.totalCodigos                       = 0
      this.arregloProblemasDiagnostico        = []
      this.arregloCodigosDiagnosticoNoexisten = []
      this.codigosNoExisten                   = []
      this.header                             = header
      this.tableData                          = results
      me.totalCodigos                         = results.length
      me.codigosPerdidos                      = false
      this.codigosNoCambiados                 = []
      this.sheetName = meta.sheetName
      this.popupConfirmTipoImportado          = true;
      this.arregloProblemasPaquete            = []
      this.arregloResumen                     = []
      this.arregloCodigosDiagnosticoNoexisten = []
      this.arregloFormatoSend                 = []
      this.arregloFormatoSendOriginal         = []
      this.tipoComboImportacion               = 0
      this.comboSelected                      = ''
      this.arrayErroresValidacionCombos       = []
      this.arrayCodigosNoEnDocumento          = []
      // Validacion combo
      /*se debe validar cuando cargue el archivo
      cuando se elije un combo
      cundo se cambia el radio
      cuando seleccione otro documento y el radio esta en columna codigo y columna combo del excel*/
      if(this.tipoBodega == 4){
        me.f_validarComboDocumento();
      }
    },
    procesarPagos(){
      let me = this
      if(me.radioRegalado === ""){
        me.$vs.notify({
        text:'Debe seleccionar un tipo por favor',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false;
      }
      //si colocan usan y liquidan
      if(me.venta_estado == 0 || me.venta_estado == null || me.venta_estado == undefined || me.venta_estado == "null" || me.venta_estado == ""){
        me.$vs.notify({
        text:'Debe seleccionar un tipo de venta por favor',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false;
      }
      if(me.checkFactura){
        if(me.factura == ""){
          me.$vs.notify({
          text:'Debe ingresar el número de factura por favor',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
      }else{
        me.factura  = ""
      }
      if(me.error){
        me.$vs.notify({
        text:'La institucion no tiene periodo',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false;
      }
      if(me.institucion_id <= 0){
        me.$vs.notify({
        text:'Seleccione una institución por favor',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-check'})
        return false
      }
      if(me.radioRegalado == 4){
        //validar que el periodoSelect no esta vacia ni nula
        if(me.periodoSelect == "" || me.periodoSelect == null || me.periodoSelect == undefined){
          me.$vs.notify({
          text:'Debe seleccionar un periodo por favor para las guias',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
        //validar que el asesorSelect no vacia ni nula
        if(me.asesorSelect == "" || me.asesorSelect == null || me.asesorSelect == undefined){
          me.$vs.notify({
          text:'Debe seleccionar un asesor por favor para las guias',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
      }
      //si escogio tipo de importacion Diagnostico
      if(me.tipoBodega == 1 || me.tipoBodega == 2){
        if(me.arregloProblemasDiagnostico.length > 0){
          me.$vs.notify({
          text:'Existe codigos de activación con problemas corriga por favor',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false
        }
      }
      //si escogio tipo de paquete
      if(me.tipoBodega == 3 || me.tipoBodega == 4){
        if(me.arregloProblemasPaquete.length > 0){
          me.$vs.notify({
          text:'Existe codigos del '+(me.tipoBodega == 3 ? 'paquete' : 'combo')+' con problemas corriga por favor',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false
        }
        if(me.arregloFormatoSend.length > 200){
          me.$vs.notify({
          text:'No puedes subir mas de 200 '+(me.tipoBodega == 3 ? 'paquetes' : 'combos'),
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
        if(me.arregloFormatoSend.length == 0){
          me.$vs.notify({
          text:'Hubo problemas para subir los '+(me.tipoBodega == 3 ? 'paquetes' : 'combos'),
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false
        }
      }
      let formData = new FormData();
      var json_pagos = ""
      if(me.tipoBodega == 3 || me.tipoBodega == 4) {  json_pagos = JSON.stringify(me.arregloFormatoSend) }
      else                                         {  json_pagos = JSON.stringify(me.tableData) }
      let comentario = ""
      var mensajeDocumento   = ""
      //proforma
      formData.append('proforma_empresa', me.proforma.empresa)
      formData.append('codigo_proforma',  me.proforma.proforma)
      if(me.proforma.proforma == null || me.proforma.proforma == "" || me.proforma.proforma == undefined){
        formData.append('ifSetProforma',0)
      }else{
        mensajeDocumento = `_agregar_${me.proforma.proforma}_${me.proforma.empresa == '1' ?'Prolipa':'Calmed'}`;
        formData.append('ifSetProforma',1)
      }
      if(me.venta_estado == '1') { comentario = "Venta directa "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura + mensajeDocumento }
      if(me.venta_estado == '2') { comentario = "Venta lista "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura + mensajeDocumento }
      if(me.radioRegalado == 1)  { comentario = "Regalado "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura + mensajeDocumento }
      if(me.radioRegalado == 2)  { comentario = "Regalado y bloqueado "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura +mensajeDocumento }
      if(me.radioRegalado == 3)  { comentario = "Bloqueado "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura + mensajeDocumento }
      if(me.radioRegalado == 4)  { comentario = "CÓDIGO GUIA "+me.nombreInstitucion+'_'+me.ciudadDescripcion+'_'+me.periodoDescripcion+'_'+me.factura + mensajeDocumento }
      formData.append('data_codigos',       json_pagos);
      formData.append('id_usuario',         me.usuario.idusuario);
      formData.append('regalado',           me.radioRegalado);
      formData.append('institucion',        'yes')
      formData.append('institucion_id',     me.institucion_id)
      if(me.radioRegalado == 4){
        formData.append('periodo_id',       me.periodoSelect.idperiodoescolar); formData.append('asesor_id',me.asesorSelect);
      }else{
        formData.append('periodo_id',       me.periodo_id)
      }
      formData.append('comentario',         comentario + ' _ ' + me.observacion)
      formData.append('factura',            me.factura)
      formData.append('venta_estado',       me.venta_estado)
      formData.append('tipoBodega',         me.tipoBodega)
      formData.append('tipoComboImportacion', me.tipoComboImportacion)
      if((me.comboSelected == "" || me.comboSelected == null || me.comboSelected == undefined)){
        //si el combo es indvidual por excel envio ifSetCombo = 1
        if(me.tipoComboImportacion == 1){
          formData.append('ifSetCombo', 1)
        }else{
          formData.append('ifSetCombo', 0)
        }
      }
      else{
        formData.append('ifSetCombo',1)
        formData.append('comboSelected',me.comboSelected)
      }
      var url = ""
      //tipo importacion Anterior
      if(me.tipoBodega === 0){
        url = this.$server_url+'codigos/import/gestion'
      }
      //tipo importacion Activacion - Diagnostico
      if(me.tipoBodega === 1 || me.tipoBodega === 2 ){
        url = this.$server_url+'codigos/import/gestion/diagnostico'
      }
      //tipo paquete
      if(me.tipoBodega === 3 || me.tipoBodega === 4 ){
        url = this.$server_url+'paquetes/importPaqueteGestion'
      }
      me.$vs.loading()
      this.$http.post(url, formData)
      .then(res => {
        me.$vs.loading.close()
        if(res.data.status == 0){
          me.m_message(res.data.message,'danger')
          return
        }
        me.$vs.notify({
        text:'Códigos procesados exitosamente',
        color:'success',
        iconPack: 'feather',
        icon:'icon-check'})
        me.modalConfirm                             = false
        me.tableData                                = []
        me.codigoConProblemas                       = res.data.codigoConProblemas
        //activacion - diagnostica normal
        if( this.tipoBodega === 1 || this.tipoBodega === 2){
          me.contadorA                              = res.data.contadorA
          me.contadorD                              = res.data.contadorD
          if(res.data.CodigosDiagnosticoNoexisten.length > 0){
            me.arregloCodigosDiagnosticoNoexisten   = res.data.CodigosDiagnosticoNoexisten
            me.popupCodigosDiagnosticoNoexisten     = true
          }
        }
        //paquetes
        if( this.tipoBodega === 3|| this.tipoBodega === 4){
          me.arregloResumen                         = res.data.arregloResumen
          me.codigoConProblemas                     = res.data.codigoConProblemas
          me.arregloErroresPaquetes                 = res.data.arregloErroresPaquetes
        }
        if( this.tipoBodega === 0){
          me.porcentaje                             = res.data.ingresados
          me.codigosNoCambiados                     = res.data.codigosNoCambiados
          me.codigosNoExisten                       = res.data.codigosNoExisten
          me.codigosSinCodigoUnion                  = res.data.codigosSinCodigoUnion
          if(me.codigosSinCodigoUnion.length > 0){
              me.popupProblemasCodigosUnion         = true
          }
        }
        me.venta_estado                             = 0
        me.factura                                  = ''
        me.observacion                              = ""
        me.codigosPerdidos                          = true
      })
      .catch(function (error) {
        me.$vs.notify({
        text:'Verifique que la información se haya guardado correctamente.',
        color:'warning',
        iconPack: 'feather',
        icon:'icon-alert-triangle'})
        me.$vs.loading.close()
        // setTimeout(function() {location.reload()}, 1000);
      })
    },
    async  openConfirm() {
      let me = this
      // Esperar 1 segundo antes de seguir
      await new Promise(resolve => setTimeout(resolve, 1000));

      if(me.arrayCodigosNoEnDocumento.length > 0){
        me.$vs.notify({
          text: `Existen ${me.arrayCodigosNoEnDocumento.length} códigos que no se encuentran en el documento seleccionado`,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        me.popupCodigosGeneralesError = true
        me.modalConfirm = false
        return
      }
      if(me.arrayErroresValidacionCombos.length > 0){
        me.$vs.notify({
          text: `Se encontraron ${me.arrayErroresValidacionCombos.length} errores en la validación de combos`,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        me.popupMostrarErroresCombosNoCoindicen = true
        return
      }
      if(me.tipoBodega == 4){
        if(me.arrayAgrupadosCombos.length === 0) {
          me.$vs.notify({
            text: 'No hay códigos asignados en los combos',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
          });
          return;
        }
      }

      if(me.proforma.proforma == null || me.proforma.proforma == "" || me.proforma.proforma == undefined){
        me.$vs.notify({
          text:'Debe seleccionar el documento',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-triangle'})
        return
      }
      if(me.proforma.empresa == null || me.proforma.empresa == "" || me.proforma.empresa == undefined){
        me.$vs.notify({
          text:'Debe seleccionar la empresa',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-triangle'})
        return
      }
      //importacion por combos
      if(me.tipoBodega == 4){
        //si elige solo la columna codigo del excel y un combo general
        let preerrorDocumentosValidate = localStorage.getItem('errorDocumentosValidate')
        if(me.errorDocumentos){
          me.m_message(preerrorDocumentosValidate,"warning",'icon-check',5000)
          return
        }
        if(me.tipoComboImportacion == 0){
          if(me.comboSelected == "" || me.comboSelected == null || me.comboSelected == undefined){
            me.$vs.notify({
            text:'Debe seleccionar un combo del libro',
            color:'warning',
            iconPack: 'feather',
            icon:'icon-check'})
            return false;
          }
        }
      }
      if(me.radioRegalado == 4){
        //validar que el periodoSelect no esta vacia ni nula
        if(me.periodoSelect == "" || me.periodoSelect == null || me.periodoSelect == undefined){
          me.$vs.notify({
          text:'Debe seleccionar un periodo por favor para las guias',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
        //validar que el asesorSelect no vacia ni nula
        if(me.asesorSelect == "" || me.asesorSelect == null || me.asesorSelect == undefined){
          me.$vs.notify({
          text:'Debe seleccionar un asesor por favor para las guias',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return false;
        }
      }
      //volver a revisar que este bien el formato del excel
      if( !me.tableData[0].codigo){
        me.$vs.loading.close()
        me.$vs.notify({ text:'Corrija el formato del excel y vuelva a intentar.', color:'warning', iconPack: 'feather', icon:'icon-alert-triangle'})
        return
      }
      if(me.arregloProblemasDiagnostico.length > 0){
        me.$vs.notify({ text:'Corrija el formato del excel y vuelva a intentar.', color:'warning', iconPack: 'feather', icon:'icon-alert-triangle'})
        return
      }
      if(me.arregloProblemasPaquete.length > 0){
        me.$vs.notify({ text:'Corrija el formato del excel y vuelva a intentar.', color:'warning', iconPack: 'feather', icon:'icon-alert-triangle'})
        return
      }
      //si selecciona un combo debe seleccionar un documento prefactura / nota
      if(me.comboSelected && me.tipoComboImportacion == 0){
        if(me.proforma.proforma == "" || me.proforma.proforma == null || me.proforma.proforma == undefined){
          me.$vs.notify({ text:'Debe seleccionar un documento prefactura / nota si se selecciona un combo', color:'warning', iconPack: 'feather', icon:'icon-alert-triangle', time:6000 })
          return
        }
      }
      if(me.errorComboEnDocumento){
        let setComboNoExisteDocumento = localStorage.getItem("setComboNoExisteDocumento")
        me.$vs.notify({ text:setComboNoExisteDocumento, color:'warning', iconPack: 'feather', icon:'icon-alert-triangle', time:6000 })
        return
      }
      if(me.tipoComboImportacion == 1){
        //el combo de tablaData no debe estar vacio
        let validateCombosVacios = me.tableData.filter(p =>
        !('combo' in p) || p.combo == ""
        );
        if (validateCombosVacios.length > 0) {
          me.m_message("En su columna de combo existe combos de libros vacios, por favor revise el archivo",'warning')
          return
        }
        //validar errorCombos
        if(me.errorCombos){
          const setComboNoExiste = localStorage.getItem("setComboNoExiste")
          me.m_message(`No existe el combo: ${setComboNoExiste} en el documento`,'warning')
          return
        }
      }
      me.errores = []
      $.each(me.tableData,function(key, value){
        if( !value.codigo){
          me.errores.push(value)
        }
      })
      if( me.errores.length > 0 ){
        me.modalErrores = true
      }else{
        me.modalConfirm = true
      }
    },
    f_validarComboDocumento(){
      let me = this
      me.errorCombos = false
      me.errorComboEnDocumento = false
      me.errorDocumentos = false
      me.arrayCombos = []
      me.arregloFormatoSend = me.arregloFormatoSendOriginal;
      //si eligen la columna codigo y combo del excel
      if(me.tipoComboImportacion == 1){
        me.comboSelected = ''

        //validar que la columna combo exista en el excel
        let validateCombosVacios = me.tableData.filter(p =>
        !('combo' in p) || p.combo === ""
        );
        if (validateCombosVacios.length > 0) {
          me.m_message("No existe su columna combo del excel o algun combo del libro vacio en su archivo del excel",'warning','icon-check',5000)
          return
        }
      }
      if(this.proforma.empresa == null || this.proforma.empresa == "" || this.proforma.empresa == undefined){
        localStorage.setItem('errorDocumentosValidate','Debe seleccionar un documento para los combos')
        me.errorDocumentos = true
        return
      }
      if(this.proforma.proforma == null || this.proforma.proforma == "" || this.proforma.proforma == undefined){
        me.errorDocumentos = true
        return
      }
      this.$http.get(this.$server_url+`metodosGetVentas?getProductoDetalleVenta=1&id_empresa=${ this.proforma.empresa }&ven_codigo=${ this.proforma.proforma }`)
      .then(function (res) {

        me.arrayCombos = res.data.filter(p => p.ifcombo == 1)
        let datos = me.arrayCombos
        if(me.tipoComboImportacion == 0){
          if(me.comboSelected == "" || me.comboSelected == null || me.comboSelected == undefined){
            // si no esta seleccionado no hacer nada
          }else{
           me.f_validacionIndividualesCombo();
          }
        }
        //si es elijen la columna  codigo y un la columna combo del excel
        if(me.tipoComboImportacion == 1){
          if(me.arrayCombos.length == 0){
            localStorage.setItem('errorDocumentosValidate','El documento no tiene combos para asignar')
            me.m_message("El documento no tiene combos para asignar","warning","icon-check",5000)
            me.errorDocumentos = true
            return
          }

          //validar que el combo del excel exista en el documento
          me.tableData.forEach(element => {
            //buscar en arrayCombos si existe el codigo colocar el documento y id_empresa
            let setCombo = me.arrayCombos.find(p => p.pro_codigo == element.combo)
            if(!setCombo){
              me.errorCombos = true
              localStorage.setItem("setComboNoExiste",element.combo)
            }
          });

          //si no hay errores en errorCombos
          if (!me.errorCombos) {
            let uniqueCombos = [...new Set(me.tableData.map(element => element.combo))]; // Extrae valores únicos
            uniqueCombos.forEach(combo => {
              let setCombo = datos.find(p => p.pro_codigo == combo);
              if (!setCombo) {
                me.m_message(`El combo ${combo} no existe en el documento de venta`, 'danger','icon-check', 5000);
                localStorage.setItem('setComboNoExisteDocumento', `El combo ${combo} no existe en el documento de venta`);
                me.errorComboEnDocumento = true;
              }else{
                me.f_validacionIndividualesCombo();
              }
            });
          }
        }
      })
      .catch(function (error) {
          console.log(error + ' error');
      })
    },
    f_validacionIndividualesCombo() {
      let me = this;
      me.errorCombos = false
      try {
        console.log("arregloFormatoSend", me.arregloFormatoSend);
        // Enriquecer arregloFormatoSend con información de combos
        me.arregloFormatoSend = me.arregloFormatoSend.map(item => {
          let comboEncontrado = null; // Inicializar comboEncontrado
          if(me.tipoComboImportacion == 0){
            comboEncontrado  = me.arrayCombos.find(combo => combo.pro_codigo === me.comboSelected);
          }else if(me.tipoComboImportacion == 1){
             // Buscar el combo en arrayAllCombos por codigo_liquidacion
           comboEncontrado = me.arrayAllCombos.find(combo => combo.codigo_liquidacion === item.combo);
          }
          if (comboEncontrado) {
            return {
              ...item,
              nombre_combo: comboEncontrado.nombre,
              codigos_combos_array: comboEncontrado.codigos_combos ? comboEncontrado.codigos_combos.split(',') : [],
              codigos_combos: comboEncontrado.codigos_combos,
              ifErrorCombo: 0,
              messageError: '',
              combo: comboEncontrado.codigo_liquidacion,
            };
          } else {
            return {
              ...item,
              nombre_combo: '',
              codigos_combos_array: [],
              codigos_combos:'',
              ifErrorCombo: 1,
              messageError: `No existe el combo ${item.combo}`,
              combo: item.combo,
            };
          }
        });

        // BUSCAR CODIGO EN CODIGOS INDIVIDUALES
        me.arregloFormatoSend =me.arregloFormatoSend.map(p => {
          return{
            ...p,
            codigosHijos:me.arrayAgrupadosCombos.filter(item => item.codigoCombo === p.codigo) || []
          }
        })

        console.log("arregloFormatoSend2", me.arregloFormatoSend);

        // Validar si algún combo no tiene códigos asignados
        let combosSinCodigos = me.arregloFormatoSend.filter(item => item.codigosHijos.length === 0);
        if (combosSinCodigos.length > 0) {
          me.errorCombos = true;
          combosSinCodigos.forEach(item => {
            me.$vs.notify({
              text: `No existe códigos asignados al combo: ${item.combo}`,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-triangle'
            });
            // Agregar al arrayErroresValidacionCombos
            me.arrayErroresValidacionCombos.push({
              codigoCombo: item.codigo,
              codigos_combos: item.codigos_combos || '',
              error: 'No existe códigos asignados al combo',
              combo: item.combo
            });
          });
          me.tableData = [];
          me.arregloProblemasPaquete = [];
          //abrir el modal de errores
          me.popupMostrarErroresCombosNoCoindicen = true;
          return;
        }


        //validar del arregloFormatoSend si no existen el combo
        me.errorCombos = me.arregloFormatoSend.some(item => item.ifErrorCombo === 1);
        if(me.errorCombos){
          me.errorComboEnDocumento = true;
          me.$vs.notify({
            text: 'No existe el combo en la base de datos' + me.arregloFormatoSend[0].combo,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
          });
          me.tableData = [];
          me.arregloProblemasPaquete = [];
        }else{
          me.f_validateCodigosDelCombo();
        }
      } catch (err) {
        console.log("err", err);
        alert("Hubo problemas con tu archivo excel");
      }
    },
    f_validateCodigosDelCombo(){
      let me = this;
      if(me.arrayAgrupadosCombos.length === 0) {
        me.$vs.notify({
          text: 'No existe codigos en los codigos en los combos',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        return;
      }
      console.log("arrayAgrupadosCombos", me.arrayAgrupadosCombos);
      console.log("arregloFormatoSendCombos", me.arregloFormatoSend);
      me.arrayAgrupadosCombos = me.arrayAgrupadosCombos.map(item => {
        // Buscar el combo en arrayAllCombos por codigo_liquidacion
        const comboEncontrado = me.arregloFormatoSend.find(combo => combo.codigo === item.codigoCombo);
        return {
          ...item,
          combo: comboEncontrado ? comboEncontrado.combo : '',
          codigosDelCombo: comboEncontrado ? comboEncontrado.codigos_combos_array : [],
          codigos_combos: comboEncontrado ? comboEncontrado.codigos_combos : '',
        }
      });
      console.log("arrayAgrupadosCombosResult", me.arrayAgrupadosCombos);
      // Array para almacenar errores de validación
      me.arrayErroresValidacionCombos = [];

      // Validar cada combo
      me.arrayAgrupadosCombos.forEach(combo => {
        let errores = [];

        // Extraer códigos de liquidación de codigosHijos
        const codigosLiquidacionHijos = combo.codigosHijos.map(hijo => hijo.codigo_liquidacion);

        // Validación 1: Misma cantidad de códigos
        if (codigosLiquidacionHijos.length !== combo.codigosDelCombo.length) {
          if (codigosLiquidacionHijos.length > combo.codigosDelCombo.length) {
            errores.push("El combo tiene más códigos de los esperados");
          } else {
            errores.push("El combo tiene menos códigos de los esperados");
          }
        }

        // Validación 2: No se pueden repetir los mismos codigo_liquidacion
        const codigosUnicos = [...new Set(codigosLiquidacionHijos)];
        if (codigosUnicos.length !== codigosLiquidacionHijos.length) {
          errores.push("Hay códigos de liquidación duplicados");
        }

        // Validación 3: Los códigos deben existir en codigosDelCombo
        const codigosFaltantes = codigosLiquidacionHijos.filter(codigo => !combo.codigosDelCombo.includes(codigo));
        const codigosSobrantes = combo.codigosDelCombo.filter(codigo => !codigosLiquidacionHijos.includes(codigo));

        if (codigosFaltantes.length > 0) {
          errores.push(`Códigos no válidos para este combo: ${codigosFaltantes.join(', ')}`);
        }

        if (codigosSobrantes.length > 0) {
          errores.push(`Faltan códigos del combo: ${codigosSobrantes.join(', ')}`);
        }

        // Si hay errores, agregar al array de errores
        if (errores.length > 0) {
          me.arrayErroresValidacionCombos.push({
            codigoCombo: combo.codigoCombo,
            codigos_combos: combo.codigos_combos,
            error: errores.join(' | '),
            combo: combo.combo,
          });
        }
      });


      // Si hay errores de validación, mostrar notificación
      if (me.arrayErroresValidacionCombos.length > 0) {
        me.$vs.notify({
          text: `Se encontraron ${me.arrayErroresValidacionCombos.length} errores en la validación de combos`,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        });
        me.popupMostrarErroresCombosNoCoindicen = true;
      }else{
        me.$vs.notify({
          text: 'Todos los codigos de cada combo del libro han sido validados correctamente',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        });
      }
    },
    f_limpiarCancelar(){
      let me = this
      me.popupConfirmTipoImportado = false
      me.comboSelected = ''
      me.errorCombos = false
      me.errorComboEnDocumento = false
      me.errorDocumentos = false
      me.arrayCombos = []
      me.arrayCodigosBloqueados = []
      me.codigosNoCambiados = ''
      me.codigosNoExisten = []
      me.arrayCodigosEncontrados = []
      me.tableData = []
      me.arregloProblemasDiagnostico = []
      me.arrayCodigosNoEnDocumento = []
    },
  }
}
</script>
<style scoped>
.tabla{
  width: 100%;
  margin-top: 10px;
}
 .tabla {

  border: 1px solid #D1E5F1;
  padding: 2px;
  border-radius: 5px;
}
.th1{
  background-color: #2D9ADA;
  border-radius: 5px;
  color:white;
}
.td1, .th1{
 padding: 10px;
 text-align: center;
 border:none;
}
/*CSS IMPORTADOR TIPO BODEGA*/

.features {
  display: flex;
  flex-direction: column;
}
.features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.features li + * {
  margin-top: 0.75rem;
}
.features .icon {
  background-color: #1FCAC5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.features .icon svg {
  width: 14px;
  height: 14px;
}
.features + * {
  margin-top: 1.25rem;
}
.text-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; /* Permite que el texto se ajuste cuando no cabe */
  width: 100%;
  box-sizing: border-box; /* Asegura que el padding no afecte el ancho total */
}

.responsive-text {
  color: red;
  font-weight: bold;
  word-wrap: break-word; /* Permite que las palabras largas se dividan en varias líneas */
  white-space: normal; /* Permite que el texto se ajuste dentro del contenedor */
  overflow: hidden;    /* Oculta cualquier texto que se desborde */
  text-overflow: ellipsis; /* Agrega puntos suspensivos al final si el texto es demasiado largo */
  max-width: 100%; /* Asegura que el texto se ajuste al contenedor */
  font-size: 1em; /* Puedes ajustar el tamaño si es necesario */
}

.text-primary {
  color: blue; /* El color para el periodo */
}
</style>
